"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function EliteCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="140147" className="grid grid-cols-1 gap-6 px-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8 lg:px-8 max-w-[1800px] mx-auto">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className={`h-[400px] lg:h-[600px] w-full animate-pulse bg-muted rounded-none ${i % 2 !== 0 ? "lg:mt-16" : ""}`} />)}
      </div>;
  }
  if (error) {
    return <div className="flex h-64 items-center justify-center text-destructive">
        <p className="font-sans text-sm uppercase tracking-widest">
          Failed to load gear collections.
        </p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-4 px-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-6 lg:px-8 max-w-[1800px] mx-auto">
      {terms.slice(0, 4).map((term, i) => <Link to={term.link || "#"} key={term.id} data-index={i} className={`group relative block h-[450px] w-full overflow-hidden bg-secondary lg:h-[700px] ${i % 2 !== 0 ? "lg:mt-24" : ""}`}>
          {}
          {term.image_url ? <img src={term.image_url} alt={term.name} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" /> : <div className="absolute inset-0 flex items-center justify-center bg-muted">
              <span className="font-sans text-xs text-muted-foreground uppercase tracking-widest">
                Texture Loading
              </span>
            </div>}

          {}
          <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

          {}
          <div className="absolute inset-0 z-20 bg-primary/0 transition-colors duration-500 ease-in-out group-hover:bg-primary/10" />

          {}
          <div className="absolute bottom-0 left-0 z-30 flex w-full flex-col items-start p-8 lg:p-10">
            <h3 className="mb-4 font-sans text-3xl font-bold uppercase tracking-tight text-white transition-transform duration-500 ease-out group-hover:-translate-y-2 lg:text-4xl">
              {term.name}
            </h3>
            
            <div className="overflow-hidden">
              <span className="inline-flex items-center font-sans text-xs font-bold uppercase tracking-[0.2em] text-primary opacity-0 transition-all duration-500 ease-out translate-y-full group-hover:translate-y-0 group-hover:opacity-100">
                Shop Now
                <ArrowRight className="ml-3 h-5 w-5 transition-transform duration-300 group-hover:translate-x-2" />
              </span>
            </div>
          </div>
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function EliteCategories() {
  return <section id="gear-by-category" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="mb-16 px-4 text-center md:px-8 lg:mb-24">
        <h2 className="font-sans text-4xl font-bold uppercase tracking-tighter text-foreground md:text-5xl lg:text-7xl">
          Kinetic Collections
        </h2>
        <div className="mx-auto mt-6 h-1 w-16 bg-primary" />
      </div>

      <EcommerceTermsProvider wp_term_query={wp_term_query}>
        <EliteCategoriesConsumer />
      </EcommerceTermsProvider>
    </section>;
}